import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class TrackingPublishYourCarWithPlateMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.title
   */
  map({page, culture, data}) {
    const {isRetry, step} = data

    const pageNames = {
      categorySelector: 'pta seleccion vehiculo',
      uploadImages: 'pta insertar fotos',
      default: 'proceso matricula formulario'
    }

    const trackingData = {
      page_name: pageNames[step] ?? pageNames.default
    }

    if (isRetry) trackingData.hit_information = 'reintentar'

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
